import React from "react";
import { Grid } from "react-bootstrap";
import id from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
import AnonymousLabel from "./AnonymousLabel";
import { Container, Brand } from "./styled";
var AnonymousNavHeader = function (props) {
    var idNamespace = id("header", props, { force: true });
    return (React.createElement(Container, null,
        React.createElement(Grid, null,
            React.createElement(Flex, { justifyContent: "space-between", width: "100%", height: "70px" },
                React.createElement(AnonymousLabel, { id: idNamespace }),
                React.createElement(Brand, { id: idNamespace })))));
};
export default AnonymousNavHeader;
